import CarrierSelector from '@/common/components/CarrierSelector/CarrierSelector'
import { subscriptionPlans } from '@/common/constants'
import CarrierInfo from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/LogisticsSection/CarrierInfo/CarrierInfo'

const CarrierService = ({ carrier, carriers, onCarrierChange, errors, subscriptionPlan, disabled }) => {
  return (
    <>
      {carrier?.supports_modification && subscriptionPlan !== subscriptionPlans.basic ? (
        <CarrierSelector
          value={carrier?.id || ''}
          onChange={onCarrierChange}
          carriers={carriers}
          errors={errors}
          disabled={disabled}
        />
      ) : (
        <CarrierInfo name={carrier?.name} serviceName={carrier?.service_name} />
      )}
    </>
  )
}

export default CarrierService
